import { render } from "./StarRating.vue?vue&type=template&id=69feb202&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=69feb202&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69feb202"

export default script